import { render } from "./GeneralDynamicParametres.vue?vue&type=template&id=6c0e06cd&scoped=true"
import script from "./GeneralDynamicParametres.vue?vue&type=script&lang=js"
export * from "./GeneralDynamicParametres.vue?vue&type=script&lang=js"

import "./GeneralDynamicParametres.vue?vue&type=style&index=0&id=6c0e06cd&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0e06cd"]])

export default __exports__